// 네트워크 전면 실패 힌트 — "왜 아무것도 안 되는가"를 유저가 스스로 알 수 있게 하는 보조 한 줄.
//
// 평상시엔 null을 반환해 기존 화면과 픽셀 단위로 동일하다.
// 단발 실패엔 절대 뜨지 않는다(판정 조건은 lib/netHealth.ts 참조).
// 디자인: docs/design.md §G — 새 색 토큰 0 · 테두리 0 · 기존 --cs-mute 보조텍스트 톤만 사용.

import type { CSSProperties } from "react";
import { useNetworkTrouble } from "../../lib/netHealth";

interface Props {
  /** 삽입처 레이아웃에 맞춘 여백/정렬 미세조정 (기본: 가운데 정렬 + 아래 여백 14) */
  style?: CSSProperties;
}

export function NetworkHint({ style }: Props) {
  const troubled = useNetworkTrouble();
  if (!troubled) return null;

  return (
    <div
      style={{
        fontSize: 12,
        color: "var(--cs-mute)",
        lineHeight: 1.5,
        textAlign: "center",
        marginBottom: 14,
        ...style,
      }}
    >
      VPN·DNS 변경 앱(유니콘 등)을 켜두면 연결이 막힐 수 있어요 · 잠시 꺼보세요
    </div>
  );
}
